import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import Config from '@/Management/GlobalConfiguration';

import ImageViewModelType from '@/ViewModels/Controls/ImageViewModel';
import LinkViewModelType from '@/ViewModels/Controls/LinkViewModel';
import { IDropdownMenuItem } from '#/CoreFrameInterfaces';

export default class DropdownMenuViewModel extends ControlViewModel {
    private ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModelType>('ImageViewModel');

    public static readonly IGNORE_CLICK_CSSCLASS: string = 'ignore-click';

    public isOpening: KnockoutObservable<boolean>;
    public linkViewModel: LinkViewModelType;
    public imageViewModel: ImageViewModelType;
    public linkStyle: string;
    /**
     * Menu Einträge
     */
    public dropdownMenuItems: KnockoutObservableArray<IDropdownMenuItem>;

    public constructor(params: any) {
        super(params);

        this.linkStyle = this.paramOrDefault(params.linkStyle, null)
        this.isOpening = this.observableOrDefault(false);
        this.imageViewModel = this.createImageViewModel();
        this.dropdownMenuItems = this.observableOrDefault(params.items, []) as KnockoutObservableArray<IDropdownMenuItem>;

        this.linkViewModel = this.paramOrDefault(params.linkViewModel);
        this.linkViewModel.onClick = () => this.toggleLinkFunction();
    }

    private toggleLinkFunction(): void {
        this.isOpening(!this.isOpening());
    }

    private createImageViewModel(): ImageViewModelType {
        return new this.ImageViewModel({
            source: Config.inlineImages.EXPANDER_EXPAND
        })
    }
}

ComponentManager.setViewModel('DropdownMenuViewModel', DropdownMenuViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');